import { createSlice } from '@reduxjs/toolkit';
import { createSpace, getSpaceData, updateSpace } from '../Services/spaceServices';

const initialState = {
  isDrawingMode: false,
  isLoading: false,
  error: null,
  spaces: [],
  spaceData: {
    backgroundImage: '',
    shapes: [],
    shapePositions: [],
  },
  currentDraggedItem: null,
  selectedItem: null,
  canvasRef:null,
};

export const mileSpaceSlice = createSlice({
  name: 'mileSpace',
  initialState,
  reducers: {
    setCanvasRef: (state, action) => {
      state.canvasRef = action.payload;
    },
    setIsDrawingMode: (state, action) => {
      state.isDrawingMode = action.payload;
    },
    setBackgroundImage: (state, action) => {
      state.spaceData.backgroundImage = action.payload;
    },
    setShapes: (state, action) => {
      state.spaceData.shapes = action.payload;
    },
    setShapePositions: (state, action) => {
      state.spaceData.shapePositions = action.payload;
    },
    updateShape(state, action) {
      const index = state.spaceData.shapes.findIndex(shape => shape.id === action.payload.id);
      if (index !== -1) {
        state.spaceData.shapes[index] = action.payload;
      }
    },
    setSelectedItem (state, action) {
        state.selectedItem = action.payload;
    },
    // loadSpaceData: (state) => {
    //   try {
    //     const savedShapes = localStorage.getItem('shapes');
    //     const savedBackgroundImage = localStorage.getItem('backgroundImage');
    //     const savedShapePositions = localStorage.getItem('shapePositions');

    //     const parsedShapes = savedShapes ? JSON.parse(savedShapes) : [];
    //     const parsedBackgroundImage = savedBackgroundImage ? JSON.parse(savedBackgroundImage) : '';
    //     const parsedShapePositions = savedShapePositions ? JSON.parse(savedShapePositions) : [];

    //     const spaceData = {
    //       backgroundImage: parsedBackgroundImage,
    //       shapes: parsedShapes,
    //       shapePositions: parsedShapePositions
    //     }
    //     state.spaceData = spaceData;
    //   } catch (e) {
    //     message.error('something went wrong000...');
    //     return;
    //   }
    // },
    setDraggedItem(state, action) {
      state.currentDraggedItem = action.payload;
    },
    clearDraggedItem(state) {
      state.currentDraggedItem = null;
    },
    importSpaceData(state,action){
      state.spaceData = {...action.payload};
    }
  },
  extraReducers: (builder) => {
    builder
      // Create Space
      .addCase(createSpace.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(createSpace.fulfilled, (state, action) => {
        state.isLoading = false;
        state.spaces.push(action.payload);
      })
      .addCase(createSpace.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      // Get All Spaces
      .addCase(getSpaceData.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getSpaceData.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action?.payload?.data) {
          state.spaceData = { ...action.payload.data };
        }
      })
      .addCase(getSpaceData.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      // Update Space
      .addCase(updateSpace.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(updateSpace.fulfilled, (state, action) => {
        state.isLoading = false;
        const index = state.spaces.findIndex((space) => space.id === action.payload.id);
        if (index !== -1) {
          state.spaces[index] = action.payload;
        }
      })
      .addCase(updateSpace.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export const {
  setIsDrawingMode,
  setBackgroundImage,
  setShapes,
  setShapePositions,
  updateShape,
  loadSpaceData,
  setDraggedItem,
  clearDraggedItem,
  setSelectedItem,
  importSpaceData,
  setCanvasRef
} = mileSpaceSlice.actions;

export default mileSpaceSlice.reducer;